import { Facility } from "./facility.model";
import { MachineTypeSubtest } from "./machine-test.model";
import { Machine } from "./machine.model";
import { ReportFormatId } from "./notification.model";
import { Organization } from "./organization.model";
import { SortableQuerySearch } from "./query-search.model";
import { User } from "./user.model";

export enum ReportTypeId {
  QC = 1,
  Equipment = 2,
  Personnel = 3,
  ChangeLog = 4,
}

export enum ReportTemplateId {
  ACR_MRI = 1,
  ACR_CT = 2,
  ACR_Mammography = 3,
  Compliance = 4,
  Audit = 5,
  None = 6,
  EquipmentLog = 7,
  Schedule = 8,
  EquipmentInventory = 9,
  UserDetails = 10,
  UserNotifications = 11,
  MRI_Visual_Checklist = 12,
  DownTime = 13,
  Data = 14,
  CrashCartInventory = 15,
  ChangeLog = 16,
  TestStatus = 17,
}

export interface Report {
  id: number;
  reportTypeId: ReportTypeId;
  userId: number | null;
  userCreatedId: number;
  updatedAt: string;
  orgId: number;
  title: string;
  time: string | null;
  facilityId: number | null;
  machineId: number | null;
  machineTypeId: number | null;
  reportTemplateId: ReportTemplateId | null;
  frequency: number | null;
  equipmentActive: boolean;
  equipmentNotActive: boolean;
  changeRecordType: string | null;
  institutionName: string | null;
  includeWeekends: boolean | null;
  ignoreNoData: boolean | null;
  fieldsSetup: boolean | null;
  fieldsInput: boolean | null;
  fieldsCalc: boolean | null;
  reportFormatId: ReportFormatId | null;
  frequencyVals: number[] | null;
  testVersionIds: number[] | null;
  org?: Organization;
  facility?: Facility;
  machine?: Machine;
  userCreated?: User;
}

export type CreateReport = Pick<Report, Exclude<keyof Report, "id" | "userCreatedId" | "updatedAt" | "org" | "facility" | "machine" | "userCreated">>;

export type ReportQuerySearch = SortableQuerySearch<Report, { facilityId?: number; machineId?: number; userId?: number }>;

export function getReportDisplayTitle(report: Pick<Report, "title" | "reportTemplateId" | "reportFormatId">): string {
  return report.title;
}
